import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { Tooltip } from '@/components/ui/Tooltip';
import { MapFillIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
import { useBuildInfoContext } from '../context/BuildInfoProvider';
import { useShowMapTemplateModal } from '../features/map-selection';
import { useBuildFormContext } from '../form/schema';
export const BuildHeaderMapTemplateButton = () => {
  const {
    canEditQuiz,
    mapTemplates
  } = useBuildInfoContext();
  const {
    t
  } = useTranslation(['build']);
  const {
    watch
  } = useBuildFormContext();
  const templateId = watch('templateId');
  const isEditorDenied = !canEditQuiz;
  const selectedMapTemplate = mapTemplates?.find(m => m.templateId === templateId);
  const selectedMapTemplateImageUrl = selectedMapTemplate?.thumbnailImage;
  const {
    open
  } = useShowMapTemplateModal();
  return <Tooltip content={t('build:build.lockRecovery.editorUnavailableTooltip')} side="bottom" className={cn('hidden', isEditorDenied && 'hidden mobile-lg:block')} trigger={<button onClick={() => {
    if (isEditorDenied) {
      return;
    }
    void open({
      from: 'header_map_button',
      isChange: !!templateId
    });
  }} className={cn('group relative shrink-0 overflow-hidden h-[30px] border rounded-sm p-4xs w-[42px] flex justify-center items-center bg-neutral', 'hidden mobile-lg:flex', !isEditorDenied && 'hover:bg-alternative hover:ring-opacity-black-3 hover:ring-2 hover:ring-offset-2', selectedMapTemplateImageUrl && 'border-none', isEditorDenied && 'cursor-default')} aria-label={t('build:mapTemplate.selectQuizMap')}>
          {selectedMapTemplateImageUrl && <>
              <img src={selectedMapTemplateImageUrl} alt="" className="absolute left-0 top-0 size-full object-cover " />
              {!isEditorDenied && <div className="absolute inset-0 hidden bg-dimmed group-hover:block" />}
            </>}
          <MapFillIcon size="xs" className={cn('hidden z-30', !selectedMapTemplateImageUrl && 'block', !isEditorDenied && 'group-hover:block')} fill={selectedMapTemplateImageUrl ? ICON_COLOR.inverse : ICON_COLOR.assistive} />
        </button>} data-sentry-element="Tooltip" data-sentry-component="BuildHeaderMapTemplateButton" data-sentry-source-file="BuildHeaderMapTemplateButton.tsx"></Tooltip>;
};